import { Component, OnInit, Output, EventEmitter, AfterViewInit, ElementRef, ViewChild, Input, OnChanges, OnDestroy } from '@angular/core';
import MetisMenu from 'metismenujs';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from '../../core/services/event.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthenticationService } from '../../core/services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() isCondensed = false;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  public imagenPerfil:string;
  public validarImagenClienteTecsa: boolean;

  menu: any;
  public permisos = [];
  menuItems = [];
  private routerSub: Subscription;
  @ViewChild('sideMenu') sideMenu: ElementRef;
  @ViewChild('componentRef') scrollRef;

  constructor(
    private eventService: EventService,
    private router: Router,
    public translate: TranslateService,
    private authService: AuthenticationService,
    private permissionsService: NgxPermissionsService,
    private user:AuthenticationService,
  ) {
    this.routerSub = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      this._activateMenuDropdown();
      this._scrollElement();
    });
  }

  ngOnInit() {
    this.loadRolesWithPermissions();
    this.initialize();
    this._scrollElement();
    const user = this.user.getUser();
    
    if(user.user.cliente.logotipo == "https://tae-system.s3.us-east-1.amazonaws.com/LogosClientes/1724699684497_Logotipo_blanco.png"){
      this.validarImagenClienteTecsa = true;
    } else {
      this.validarImagenClienteTecsa = false
      this.imagenPerfil = user.user.cliente.logotipo;
    }
    this.permisos = this.authService.getPermissions();
    // console.log('Permisos:', this.permisos); // Para depuración
    // console.log('Elementos del menú:', this.menuItems); // Para depuración
  }
  ngAfterViewInit() {
    this._initMetisMenu();
    this._activateMenuDropdown();
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
    this._disposeMetisMenu();
  }

  private _disposeMetisMenu() {
    if (this.menu) {
      try {
        this.menu.dispose();
      } catch {
        // MetisMenu ya no está en el DOM
      }
      this.menu = null;
    }
  }

  private _initMetisMenu() {
    if (!this.sideMenu?.nativeElement) {
      return;
    }
    this._disposeMetisMenu();
    this.menu = new MetisMenu(this.sideMenu.nativeElement, {
      toggle: true
    });
  }

  onParentClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const selectedItem = (event.currentTarget as HTMLElement).closest('li');
    if (selectedItem) {
      this._toggleSubmenu(selectedItem);
    }
  }

  _keepSubmenuOpen(selectedItem: HTMLElement) {
    let parentEl = selectedItem.closest('li');
    document.querySelectorAll('#side-menu > li.mm-active').forEach((item) => {
      if (item !== parentEl) {
        item.classList.remove('mm-active');
        let subMenu = item.querySelector('.sub-menu');
        if (subMenu) {
          subMenu.classList.remove('mm-show');
        }
      }
    });
  
    while (parentEl && parentEl.id !== 'side-menu') {
      parentEl.classList.add('mm-active');
  
      let subMenu = parentEl.querySelector('.sub-menu');
      if (subMenu) {
        subMenu.classList.add('mm-show');
      }
  
      parentEl = parentEl.parentElement?.closest('li') || null;
    }
  }
  
  _toggleSubmenu(selectedItem: HTMLElement) {
    const parentList = selectedItem.parentElement;
    parentList?.querySelectorAll(':scope > li.mm-active').forEach((item) => {
      if (item !== selectedItem) {
        item.classList.remove('mm-active');
        item.querySelector(':scope > .sub-menu')?.classList.remove('mm-show');
        item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
      }
    });

    const isOpen = selectedItem.classList.toggle('mm-active');
    const subMenu = selectedItem.querySelector(':scope > .sub-menu');
    if (subMenu) {
      subMenu.classList.toggle('mm-show', isOpen);
    }
    selectedItem.querySelector(':scope > a')?.setAttribute('aria-expanded', String(isOpen));
  }
  
  

  ngOnChanges() {
    setTimeout(() => {
      this._initMetisMenu();
      this._activateMenuDropdown();
    });
  }

  loadRolesWithPermissions() {
    this.permissionsService.flushPermissions();
    const permissions = this.authService.getPermissions();
    // console.log('Cargando permisos:', permissions);
    this.permissionsService.loadPermissions(permissions);
  }

  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  darkSidebar() {
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('vertical-collpsed');
  }

  compactSidebar() {
    document.body.setAttribute('data-sidebar-size', 'small');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('vertical-collpsed');
  }

  iconSidebar() {
    document.body.classList.add('sidebar-enable');
    document.body.classList.add('vertical-collpsed');
    document.body.setAttribute('data-sidebar-size', 'sm');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-topbar');
  }

  boxedLayout() {
    document.body.setAttribute('data-keep-enlarged', 'true');
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.classList.add('vertical-collpsed');
    document.body.classList.remove('sidebar-enable');
    document.body.removeAttribute('data-topbar');
  }

  coloredSidebar() {
    document.body.setAttribute('data-sidebar', 'colored');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-topbar');
  }

  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar) {
            if (this.scrollRef.SimpleBar.getScrollElement() !== null) {
              this.scrollRef.SimpleBar.getScrollElement().scrollTop =
                currentPosition + 300;
            }
          }
      }
    }, 300);
  }

  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    document.querySelectorAll('#side-menu .side-nav-link-ref.active').forEach((link) => {
      link.classList.remove('active');
    });

    const links = document.querySelectorAll('.side-nav-link-ref') as NodeListOf<HTMLElement>;
    let menuItemEl: HTMLElement | null = null;
    const currentUrl = (this.router.url || '').split('?')[0];

    links.forEach((link) => {
      const routerLink = (link.getAttribute('ng-reflect-router-link') || '').trim();
      const href = (link.getAttribute('href') || '').replace(/^#/, '');
      const candidate = (routerLink ? `/${routerLink.replace(/,/g, '/')}` : href).replace(/\/{2,}/g, '/');
      if (candidate && candidate !== '/' && (currentUrl === candidate || currentUrl.startsWith(`${candidate}/`))) {
        menuItemEl = link;
      }
    });

    if (menuItemEl) {
      menuItemEl.classList.add('active');
      this._keepSubmenuOpen(menuItemEl.closest('li'));
    }
  }

  initialize(): void {
    this.menuItems = MENU;
  }

  hasItems(item: MenuItem): boolean {
    return this.hasPermission(item.permiso) && item.subItems !== undefined && item.subItems.some(subItem => this.hasPermission(subItem.permiso));
  }

  hasPermission(permiso: string | undefined): boolean {
    if (!permiso) {
      return true;
    }
    return this.permisos.includes(permiso);
  }

  trackByFn(index: number, item: MenuItem): number {
    return item.id;
  }
}
